import RestAPI from '../Common/restApi';

export default class Api {
  static fetchJobsList(page, pageSize, filters) {
    return RestAPI.getWithQueryString('/alpha/jobs/jobs_list', {
      page: page,
      page_size: pageSize,
      ...filters,
    });
  }

  static exportJobs(filters) {
    return RestAPI.postWithFormData('/alpha/jobs/export_jobs_list', {
      filters: filters,
    });
  }
}
